import { FormMetadataByWorkspace } from 'state/forms/metadata/model';
import { HandledWorkspace } from 'state/forms/models';
import { AppState } from 'state/state.model';

export function getFormMetadataByFormId<T extends HandledWorkspace>(
  state: AppState,
  workspace: T,
  formId: string,
): FormMetadataByWorkspace<T> | undefined {
  if (state.metadata[formId]?.workspace !== workspace) {
    return undefined;
  }
  return state.metadata[formId] as FormMetadataByWorkspace<T> | undefined;
}

export function getProductDescription(state: AppState, formId: string) {
  return getFormMetadataByFormId(state, 'dynamic', formId)?.productGraph;
}
export function getFieldsMetadata(state: AppState, workspace: HandledWorkspace, formId: string) {
  return getFormMetadataByFormId(state, workspace, formId)?.fields;
}
export function getBlocksMetadata(state: AppState, workspace: HandledWorkspace, formId: string) {
  return getFormMetadataByFormId(state, workspace, formId)?.blocks;
}
